import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext, useEffect } from "react";
import ClassNames from "classnames";
import { getKeyTable } from "../utils/NavUtils";
import DateSinglePickerContext from "../context/DateSinglePickerContext";
import DatepickerInput from "./DatepickerInput";
import CalendarPickerContext from "../context/CalendarPickerContext";
import CalendarWrapper from "./CalendarPortalWrapper";
import { usePrevious } from "../utils/utils";
var DateRangePicker = function DateRangePicker(props) {
  var dateSeparator = props.dateSeparator,
    value = props.value,
    className = props.className,
    format = props.format,
    rangeConnecterFormat = props.rangeConnecterFormat;
  var _useContext = useContext(CalendarPickerContext),
    openStatusStore = _useContext.openStatusStore,
    openStatusDispatch = _useContext.openStatusDispatch,
    dateValidator = _useContext.dateValidator,
    valueDispatch = _useContext.valueDispatch,
    activeStartDateDispatch = _useContext.activeStartDateDispatch,
    keyboardControlAreaDispatch = _useContext.keyboardControlAreaDispatch,
    inputValueStore = _useContext.inputValueStore,
    inputValueDispatch = _useContext.inputValueDispatch,
    setHasInputError = _useContext.setHasInputError,
    dateCalculator = _useContext.dateCalculator,
    inputRefList = _useContext.inputRefList,
    editForbidden = _useContext.editForbidden;
  var isOpen = openStatusStore.isOpen,
    disabled = openStatusStore.disabled,
    readonly = openStatusStore.readonly;
  var dpRef = React.useRef(null);
  useEffect(function () {
    setDatepickerRef(dpRef.current);
  }, [dpRef.current]);
  var closeCalendar = function closeCalendar(isKeyboard) {
    openStatusDispatch({
      type: "closeWithValidation",
      payload: {
        inputValue: inputValueStore.inputValue,
        setHasInputError: setHasInputError,
        selectRange: true,
        isKeyboard: isKeyboard,
        editForbidden: editForbidden,
        panelValue: value
      }
    });
  };
  var prevValue = usePrevious(value);
  useEffect(function () {
    if (!dateValidator.isSameDates(prevValue, value)) {
      inputValueDispatch({
        type: "setInputValueByDate",
        payload: {
          value: value
        }
      });
    }
  }, [value, dateSeparator]);
  useEffect(function () {
    inputValueDispatch({
      type: "setInputValueByDate",
      payload: {
        value: value
      }
    });
  }, [dateSeparator, format, rangeConnecterFormat]);
  var autoComplete = function autoComplete() {
    var inputValue = inputValueStore.inputValue;
    var isValid = dateValidator === null || dateValidator === void 0 ? void 0 : dateValidator.isValidFormatDateString(inputValue);
    if (isValid) {
      if (inputValue !== '') {
        var completedInputValue = dateCalculator.calculateDatestringFromDateValues(inputValue, inputValue, true);
        inputValueDispatch({
          type: "setInputValueByString",
          payload: {
            value: completedInputValue
          }
        });
        var _value = dateCalculator.calculateDateValuesFromDateString(completedInputValue);
        activeStartDateDispatch({
          type: "setActiveStartDate",
          payload: {
            activeStartDateLeft: _value[0]
          }
        });
        valueDispatch({
          type: "setValue",
          payload: {
            value: _value
          }
        });
      }
    }
  };
  var isValidRangeFormatDate = function isValidRangeFormatDate() {
    var isValidFormat = dateValidator._isValidFormatRangeDate(inputValueStore.inputValue);
    return isValidFormat;
  };
  var isValidSingleFormatDate = function isValidSingleFormatDate() {
    var isValidFormat = dateValidator._isValidFormatSingleDate(inputValueStore.inputValue);
    return isValidFormat;
  };
  var onKeyDown = function onKeyDown(event) {
    var _getKeyTable = getKeyTable(event),
      isTab = _getKeyTable.isTab,
      isEsc = _getKeyTable.isEsc;
    if (disabled || readonly) {
      return;
    }
    if (isTab) {
      if (!isOpen) {
        var resValue = null;
        if (isValidRangeFormatDate()) {
          resValue = editForbidden ? value : dateCalculator.calculateDateValuesFromDateString(inputValueStore.inputValue);
          if (!resValue) return;
          activeStartDateDispatch({
            type: "setActiveStartDate",
            payload: {
              activeStartDateLeft: resValue && resValue[0] || null
            }
          });
          valueDispatch({
            type: "setValue",
            payload: {
              value: resValue
            }
          });
        } else {
          if (isValidSingleFormatDate()) {
            if (!editForbidden) autoComplete();
          } else {
            activeStartDateDispatch({
              type: "init",
              payload: {}
            });
            valueDispatch({
              type: "setValue",
              payload: {
                value: resValue
              }
            });
          }
        }
      } else {
        keyboardControlAreaDispatch({
          type: "setNavWhenPressTab",
          payload: {
            event: event
          }
        });
      }
    } else if (isEsc && isOpen) {
      closeCalendar(true);
      keyboardControlAreaDispatch({
        type: "setInputFocus",
        payload: {
          isKeyboard: true
        }
      });
    }
  };
  var _React$useState = React.useState(null),
    datepickerRef = _React$useState[0],
    setDatepickerRef = _React$useState[1];
  var DateSinglePickerStore = {
    datepickerRef: datepickerRef,
    setDatepickerRef: setDatepickerRef
  };
  return /*#__PURE__*/React.createElement(DateSinglePickerContext.Provider, {
    value: DateSinglePickerStore
  }, /*#__PURE__*/React.createElement("div", {
    className: ClassNames("react-daterange-picker", className),
    ref: dpRef,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement(DatepickerInput, _extends({}, props, {
    closeTrigger: closeCalendar
  })), /*#__PURE__*/React.createElement(CalendarWrapper, _extends({}, props, {
    isOpen: isOpen,
    containerRef: inputRefList[2],
    closeTrigger: closeCalendar
  }))));
};
export default DateRangePicker;